export default __webpack_public_path__ + "static/image15-6147b70e0fdfa77c1409dc8c942cc83d.gif";